import { useTranslation } from 'react-i18next';
import { Box } from 'reflexbox';
import { useRouteMatch } from 'react-router';

import { ChevronLeftIcon } from '@treams/treams-icons';
import { Container, Button, Toolbar, Title, Paragraph, Author } from '@treams/treams-ui';

import * as graphql from 'generated/graphql';

import QuillText from '../packages/kakapo-ui-kit/components/editors/QuillText';

export default function Compliment() {
	const { t } = useTranslation();

	const { params } = useRouteMatch<{ userID?: string; id: string }>();
	const { userID, id } = params;

	const query = graphql.useComplimentQuery({ variables: { id } });

	return (
		<Container py={4}>
			<Toolbar>
				<Button
					icon={<ChevronLeftIcon />}
					link={userID ? `/users/${userID}/feedback/compliments` : '/feedback/compliments'}
					title={t('goals.show.toolbar.back')}
					type="secondary"
				/>
			</Toolbar>

			<Box mt={4}>
				{query.data ? (
					<>
						<Title mb={3}>
							{query.data.compliment.sender.isViewer
								? t('compliment.detail.outgoingTitle', {
										name: query.data.compliment.recipient.firstName,
								  })
								: t('compliment.detail.title', { name: query.data.compliment.sender.firstName })}
						</Title>
						<Box mb={3}>
							<QuillText quill={query.data.compliment.text} />
						</Box>
						<Author
							user={
								(query.data.compliment.sender.isViewer
									? query.data.compliment.recipient
									: query.data.compliment.sender) as graphql.User
							}
							description={t('compliment.detail.author.createdAt')}
							createdAt={query.data.compliment.createdAt}
						/>
					</>
				) : (
					<>
						<Title.Skeleton mb={3} />
						<Paragraph.Skeleton mb={3} />
						<Author.Skeleton />
					</>
				)}
			</Box>
		</Container>
	);
}
